"use client"
import React, { useState } from "react";
import Image from "next/image";
import logoimage from "../../../public/oauthimage.png";
import { signIn, useSession } from "next-auth/react"


async function getPublicIP() {
  const res = await fetch('https://api.ipify.org?format=json');
  const data = await res.json();
  return data.ip; // e.g. "203.0.113.42"
}

export default function LoginComponent() {
  const [error, setError] = useState(false);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 auto-rows-min m-3">
      {/* Login head image */}
      <div className="m-1 w-80 sm:w-96 text-3xl flex-grow place-content-center place-items-center col-span-full row-start-1">
        {error && (
          <div className="alert alert-error flex-grow place-content-center place-items-center">
            Incorrect username or password.
          </div>
        )}
        Welcome back
        <br />
        <Image
          priority
          src={logoimage}
          width={200}
          height={200}
          alt="Logo image"
          className="overflow-hidden rounded-full mt-5"
        />
      </div>
      <div className="col-span-full bg-base-200 border border-base-200 rounded-2xl ring ring-base-300 shadow mt-4 w-80 sm:w-96">
        <form action={async () => {
          signIn("credentials", {
            email: (document.getElementById("email") as HTMLInputElement)?.value,
            password: (document.getElementById("password") as HTMLInputElement)?.value,
            ip: await getPublicIP()
          });
        }}>
          <fieldset className="fieldset p-4">
            <label className="fieldset-label">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className="input"
              placeholder="Email"
              required
            />

            <label className="fieldset-label">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              className="input"
              placeholder="Password"
              required
            />

            <button type="submit" className="btn btn-primary mt-4">
              Login
            </button>
          </fieldset>
        </form>
      </div>

      <div className="row-start-3 col-span-full w-80 sm:w-96">
        <div className="flex items-center my-4">
          <hr className="flex-grow border-t" />
          <span className="mx-3">OR</span>
          <hr className="flex-grow border-t" />
        </div>
      </div>
      <div className="row-start-4 col-span-full">
        <button className="btn rounded-full w-80 sm:w-96 bg-white text-black border-[#e5e5e5]">
          {/* Google Icon */}
          <svg
            aria-label="Google logo"
            width="32"
            height="32"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <g>
              <path d="m0 0H512V512H0" fill="#fff"></path>
              <path
                fill="#34a853"
                d="M153 292c30 82 118 95 171 60h62v48A192 192 0 0190 341"
              ></path>
              <path
                fill="#4285f4"
                d="m386 400a140 175 0 0053-179H260v74h102q-7 37-38 57"
              ></path>
              <path
                fill="#fbbc02"
                d="m90 341a208 200 0 010-171l63 49q-12 37 0 73"
              ></path>
              <path
                fill="#ea4335"
                d="m153 219c22-69 116-109 179-50l55-54c-78-75-230-72-297 55"
              ></path>
            </g>
          </svg>
          Login with Google
        </button>
        <br />
        <br />
        <button className="btn rounded-full w-80 sm:w-96 facebook bg-[#1A77F2] text-white border-[#005fd8]">
          {/* Facebook icon */}
          <svg
            aria-label="Facebook logo"
            width="32"
            height="32"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
          >
            <path
              fill="white"
              d="M8 12h5V8c0-6 4-7 11-6v5c-4 0-5 0-5 3v2h5l-1 6h-4v12h-6V18H8z"
            ></path>
          </svg>
          Login with Facebook
        </button>
      </div>
    </div>
  );
}
